<script setup lang="ts">
const { smallGrid } = useProductGridOptions()

const number = Array.from({ length: 3 }).keys()
const numberOfDots = [...number]
</script>

<template>
  <div class="container">
    <div
      class="image"
      :class="[{ 'image--small': smallGrid }]"
    />
    <div
      class="content"
      :class="[{ hidden: smallGrid }]"
    >
      <div :class="[{ hidden: smallGrid }]">
        <div class="dots">
          <ProductGridSkeletonDot
            v-for="dot in numberOfDots"
            :key="dot"
            :class="[{ hidden: smallGrid }]"
          />
        </div>
        <div
          class="title"
          :class="[{ hidden: smallGrid }]"
        />
        <div
          class="title title--mobile"
          :class="[{ hidden: smallGrid }]"
        />
        <div
          class="price"
          :class="[{ hidden: smallGrid }]"
        />
      </div>
      <div
        class="cart-container"
        :class="[{ hidden: smallGrid }]"
      >
        <div
          class="cart"
          :class="[{ hidden: smallGrid }]"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'assets/scss/rules/breakpoints';

.container {
    background-color: var(--white);
}

.content {
    display: flex;
    padding: 0 1.4rem 2.4rem;
    flex-direction: column;
    justify-content: space-between;
}

.image,
.title,
.price,
.cart,
.dots:deep(.circle) {
    background-color: var(--gray);
    background: linear-gradient(110deg, #ececec 20%, #f5f5f5 30%, #ececec 43%);
    background-size: 200% 100%;
    animation: 1.5s loading linear infinite;

    @media (prefers-reduced-motion) {
        background: var(--gray);
        animation: none;
    }
}

.image {
    aspect-ratio: 4 / 5;
}

.image--small {
    min-height: 18.8rem;
    max-width: 100%;
}

.title,
.price {
    border-radius: 5rem;
}

.title {
    height: 2.4rem;
    width: 60%;
    margin: 1rem 0;

    &--mobile {
        @media(min-width: $phablet) {
            display: none;
        }
    }
}

.price {
    height: 2.4rem;
    width: 4rem;
}

.cart {
    height: 4rem;
    width: 4rem;
    border-radius: 50%;

    &-container {
        display: flex;
        justify-content: flex-end;

        @media(min-width: $laptop) {
            visibility: hidden;
        }
    }
}

.hidden {
    display: none;
}

.dots {
    gap: 0.6rem;
    display: flex;
    flex-direction: row;
    line-height: 1.71;
    align-items: center;
    height: 2.5rem;
    margin: 4rem 0 2rem;
}

@keyframes loading {
    to {
        background-position-x: -200%;
    }
}
</style>
